export default {
    state: {
        ports: []
    }
}